export default '/build/ce0d18e5.svg'